// extracted by mini-css-extract-plugin
module.exports = {"o-page-header":"PageHeader_o-page-header__3svLS"};